// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/ajax-locations');
require('@js/ajax-events');
require('@js/header');
require('@js/sliders');
require('@js/logo-rotate');
require('@js/games-accordion');
require('@js/faq');
require('@js/parallax');
require('@js/menu');
require('@js/title-move');
require('@js/location-gallery');
require('@js/cookies');

require('@js/index');